import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Article } from 'src/app/blog/blog-models/Article';
import { ArticleService } from '../blog-services/article.service';

@Component({
  selector: 'app-single-article',
  templateUrl: './single-article.component.html',
  styleUrls: ['./single-article.component.scss']
})
export class SingleArticleComponent implements OnInit {

    article: Article;

    constructor(private articleService: ArticleService, private route: ActivatedRoute, private router: Router) { }

    ngOnInit(): void {
        const id = +this.route.snapshot.params['id'];
        console.log(id);
        
        this.article = new Article();
        this.articleService.getArticleByIdFromServer(id).then(
            (dataArticle: Article) => {
                this.article = dataArticle;
                if(!this.article) {
                    this.router.navigate(["not-found"]);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }
}
